import { Client } from '../organization/organization.types';

export interface UserSubscription {
  readonly isInvoice: boolean;
}

export interface IUserState {
  extUserId: string;
  firstName?: string;
  lastName?: string;
  fullname?: string;
  email: string;
  date_of_birth?: string;
  zip_code?: string;
  phone_number?: string;
  permissions?: {
    groups: string[];
  };
  user_details?: object;
  organization?: {
    name: string;
    id: string;
  };
  client?: Client;

  refresh: string;
  access: string;

  signOutInProgress: boolean;
  isSignedIn: boolean;
  isSuperAdmin: boolean;
}

export const defaultUserState: IUserState = {
  extUserId: '',
  email: '',
  refresh: '',
  access: '',
  signOutInProgress: false,
  isSignedIn: false,
  isSuperAdmin: false,
};
